import { FunctionComponent } from "react";
import { Heading } from "@chakra-ui/react";

import { ReactComponent as HelloIcon } from "src/assets/images/hello_icon.svg";

type Props = {
  userName: string;
};
export const Greeting: FunctionComponent<Props> = ({ userName }) => {
  return (
    <>
      <Heading
        as="h3"
        fontSize={"22px"}
        color="#0B0A0A"
        textTransform={"capitalize"}
        display={"flex"}
        alignItems={"center"}
        gap={2}
      >
        Hello, {userName} <HelloIcon style={{ width: "25px" }} />
      </Heading>
    </>
  );
};
